import { apiSlice } from "../../apiSlice";

const headers = { Modulecima: "Modimpxx" };

export const causapayApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getProviders: builder.mutation({
      query: (parameters) => ({
        url: `/Modimpxx/Causapay/getProvider`,
        method: "GET",
        params: { filter: parameters.filter },
        headers,
      }),
    }),
    getInvoiceProviders: builder.mutation({
      query: (parameters) => ({
        url: `/Modimpxx/Causapay/getInvoiceProvider`,
        method: "GET",
        params: parameters,
        headers,
      }),
    }),
    createPagoCausacion: builder.mutation({
      query: (parameters) => ({
        url: `/Modimpxx/Causapay`,
        method: "POST",
        body: parameters,
        headers
      }),
      invalidatesTags: ["Create"],
    }),
    getClientById: builder.mutation({
      query: (parameters) => ({
        url: `/Modimpxx/Causapay/getClientById`,
        method: "GET",
        params: { filter: parameters.filter },
        headers,
      }),
    }),
    getProviderByTask: builder.mutation({
      query: (parameters) => ({
        url: `/Modimpxx/Causapay/getProviderByTask`,
        method: "GET",
        params: parameters,
        headers,
      }),
    }),
    getTaskInvoice: builder.mutation({
      query: (parameters) => ({
        url: `/Modimpxx/Causapay/getTaskInvoice`,
        method: "POST",
        body: parameters,
        headers,
      }),
    }),
    //Estado de los DO de una solicitud de Gestion Contable (RQ402): devuelve
    //por DO si bloquea la solicitud y el mensaje para el usuario
    getStateOperations: builder.mutation({
      query: (parameters) => ({
        url: `/Modimpxx/Causapay/getStateOperations`,
        method: "POST",
        body: parameters,
        headers,
      }),
    }),
  }),
});

export const {
  useGetProvidersMutation,
  useGetInvoiceProvidersMutation,
  useCreatePagoCausacionMutation,
  useGetClientByIdMutation,
  useGetProviderByTaskMutation,
  useGetTaskInvoiceMutation,
  useGetStateOperationsMutation,
} = causapayApiSlice;
